import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetDrugsCategoryActivities(id: string | undefined) {
  return useQuery(queries.basicData.getDrugCategoryActivitiesById(id || ''))
}
